import map from "lodash/map";
import find from "lodash/find";
import first from "lodash/first";
import React from "react";
import set from "@rill/set";
import SupportNav from "../../../parts/support-nav";

const VIDEOS = [
  // Welcome Video
  { title: "Welcome", id: "bqPco0e9UGc" },

  // General Videos
  { title: "How to Build a Workout", id: "Y8mDUfRjano" },
  {
    title: "Creating a Training Program (1/3): How to Create a Training Cycle",
    id: "6FV9DqGWPnY",
  },
  {
    title:
      "Creating a Training Program (2/3): Difference Between Cycle and Program",
    id: "gqZTJ_-psj0",
  },
  {
    title: "Creating a Training Program (3/3): How to Add Programs to Calendar",
    id: "mdNmdOSBObE",
  },
  { title: "Move, Delete, and Edit Calendar Days", id: "clv6fWFP5MA" },
  {
    title: "Difference Between Standard and Premium Programs",
    id: "NIvTvyjaH2I",
  },
  { title: "Finding Your Perfect Program", id: "mPZdPRom_JU" },
  { title: "3 Types of Exercises", id: "TpfI7I96EpM" },
  { title: "Managing Your Exercise Library", id: "MqzFeF7z6YI" },
  { title: "How to Copy Workouts", id: "Tlp31hrY3pA" },
  { title: "Rep Maxes: Primary and Secondary Exercises", id: "76MfiLu1cOA" },
  { title: "Building Climbing Sets", id: "ZF_wEGVDtVM" },
  { title: "Program Builder: Quick Metrics", id: "KT7I4afy0hs" },
  { title: "Welcome to MyStrengthBook", id: "cmFvX2xDqbY" },

  // Metric Page Videos
  { title: "Volume and Intensity", id: "DuIf0_Y0IrQ" },
  { title: "Baseline Volume and Relative Intensity", id: "RCixQs9Zo4s" },
  { title: "Over and Under Baseline Volume", id: "VE0M8K88jw8" },
  { title: "Volume Split by Core Lift:", id: "jjfWplqDHEs" },
  { title: "Personal Record Table", id: "xEknnLP5Ns8" },
  { title: "Primary and Secondary Volume Split", id: "clABRxPmTVA" },
  { title: "Raw and Equipped Volume Split", id: "IQQwEQj8ctw" },
  { title: "Competition History", id: "WNvTFol9eNs" },
  { title: "Number of Lifts", id: "yrNdwCXQv2Y" },

  // Dashboard Metric Videos
  { title: "Dashboard Metrics: 12-Week Baseline Volume", id: "zZHFvhoMD1k" },
  {
    title: "Dashboard Metrics: 12-Week Zone of Relative Intensity",
    id: "bgd29IZekrQ",
  },
];

function View(props, { locals }) {
  const { query } = locals;
  const autoPlay = Number(Boolean(query.video));
  const activeVideo = find(VIDEOS, { id: query.video }) || first(VIDEOS);
  return (
    <div className="Main Support-Videos">
      <SupportNav />

      <div className="Content">
        <div className="Now-Playing">
          <div className="video">
            <iframe
              src={`https://www.youtube.com/embed/${activeVideo.id}?rel=0&amp;showinfo=0&amp;autoplay=${autoPlay}`}
              allowFullScreen
            ></iframe>
          </div>
          <div className="caption">
            NOW PLAYING
            <div className="title">{activeVideo.title}</div>
          </div>
        </div>

        <h4>How-to Videos</h4>

        <div className="Videos">
          {map(VIDEOS, ({ id, title }) => {
            return (
              <div key={id} className="item">
                <div
                  className="image"
                  style={{
                    backgroundImage: `url(http://img.youtube.com/vi/${id}/0.jpg)`,
                  }}
                />
                <div className="title">{title}</div>
                <a href={`?video=${id}`}></a>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

const Videos = (app) => {
  app.get("/videos", set("heading", ["Video Resources"]), ({ req, res }) => {
    res.body = <View />;
  });
};

export default Videos;
